import { useQuery } from "@tanstack/react-query";

import {
  getActorsActorIDTransactions,
  type TransactionType,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { ACTORS_QUERY_KEYS } from "./queryKeys";

export interface ActorTransactionsQueryParams {
  offset?: number;
  limit?: number;
  transactionType?: TransactionType | null;
}

export function useActorTransactionsQuery(
  actorID: string,
  params: ActorTransactionsQueryParams,
) {
  return useQuery({
    queryKey: ACTORS_QUERY_KEYS.transactions(actorID, params),
    queryFn: processResponse(() =>
      getActorsActorIDTransactions(
        actorID,
        params.offset,
        params.limit,
        params.transactionType,
      ),
    ),
  });
}
